import React from 'react';
import {
    Box,
    Grid,
    Paper,
    Snackbar,
    Table,
    TableBody,
    TableContainer,
    Typography
} from "@mui/material";
import {QueryResultsHeaders} from "../../../pages/QueryPage/components/QueryResultsHeaders/QueryResultsHeaders";
import {QueryResultsRow} from "../../../pages/QueryPage/components/QueryResultsRow/QueryResultsRow";

export const QueryResultsTable = (
    {
        rows,
        limit,
        sport
    }: {
        rows: any[],
        limit: number,
        sport: string
    }
) => {

    return (
        <>
            <Typography
                component="p"
                variant="caption"
                align="center"
                color="grey"
                mt={2}
            >
                Results for {sport.toUpperCase()} query string
            </Typography>
            <TableContainer
                component={Paper}
                style={{
                    maxWidth: '96%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '4px',
                    marginBottom: '32px',
                    height: '150px',
                    overflow: 'auto'
                }}
            >
                <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
                    <QueryResultsHeaders queryHasAtClause={false} />
                    <TableBody>
                        {rows
                            ?.sort((a: { date: number }, b: any) => b.date - a.date)
                            .map((row: any, index: number) => (
                                <QueryResultsRow
                                    row={row}
                                    key={index}
                                    queryHasAtClause={false}
                                />
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}